import PropTypes from 'prop-types';
import { creatorType } from '~/types/creator';
import { ytChannelType } from '~/types/ytChannel';

export const ytContentType = PropTypes.shape({
  id: PropTypes.string,
  ytVideoId: PropTypes.string,
  creator: creatorType,
  ytChannel: ytChannelType,
  title: PropTypes.string,
  description: PropTypes.string,
  thumbnails: PropTypes.shape({
    default: PropTypes.shape({
      url: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    medium: PropTypes.shape({
      url: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    high: PropTypes.shape({
      url: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
  }),
  tags: PropTypes.arrayOf(PropTypes.string),
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  publishedAt: PropTypes.string,
  shareLink: PropTypes.string,
  isPasswordProtected: PropTypes.bool,
  commentCount: PropTypes.number,
  dislikeCount: PropTypes.number,
  favoriteCount: PropTypes.number,
  likeCount: PropTypes.number,
  viewCount: PropTypes.number,
});
